import { render } from "./JMessageArticleList.vue?vue&type=template&id=6fe38189&scoped=true&ts=true"
import script from "./JMessageArticleList.vue?vue&type=script&lang=ts"
export * from "./JMessageArticleList.vue?vue&type=script&lang=ts"

import "./JMessageArticleList.vue?vue&type=style&index=0&id=6fe38189&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe38189"]])

export default __exports__